// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1070":"2082ed2f","7239":"75e79f54"}[chunkId] + ".chunk.css";
};